import React from 'react'
import type { TopicTagsFragment } from '../../../.graphql/generated-types'
import { notEmpty } from '@marketing-sites/utils'
import { TopicTag } from '../TopicTag'

export interface TopicTagsProps {
  data: TopicTagsFragment
}

export function TopicTags({ data }: TopicTagsProps) {
  const items = data.items
    .filter(notEmpty)
    .map((topic) => <TopicTag key={topic.sys.id} data={topic} />)
  return <ul className="mb-2 flex flex-wrap space-x-2">{items}</ul>
}
